module.exports = __webpack_public_path__ + "img/linkd2-1.9f9d6d68.jpg";